const getters = {
  token: state => state.user.token,
  user: state => state.user.user,
  indexUser: state => state.indexUser.todaydate,
  indexTodo: state => state.indexTodo.todo,
  indexNotice: state => state.indexUser.notice,
  indexSystemType: state => state.indexUser.SystemType
}
export default getters